module.exports = __webpack_public_path__ + "static/img/CPR.78db962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CPR.png
// module id = 46YZ
// module chunks = 1